export function XML_CreateTriPath(sx, sy, ex, ey, r, boxShape, triPosition, drawElement) {
  drawElement.CreateTriPath(sx, sy, ex, ey, r, boxShape, triPosition);
}
